const columns = [
  {
    dataField: 'shipment_id',
    text: 'Shipment ID',
    type: 'entity',
    entityType: 'shipment',
    hideable: false,
    sort: true,
    localizationSlug: 'SHIPMENT_ID',
    formatExtraData: {
      showPreNoticeBadge: true
    }
  },
  {
    dataField: 'status',
    text: 'Status',
    type: 'status',
    hideable: true,
    sort: true,
    localizationSlug: 'STATUS',
  },
  {
    dataField: 'reference_numbers',
    text: 'Reference Numbers',
    type: 'reference_number',
    hideable: true,
    sort: true,
    headerStyle: {
      width: '14%',
    },
    localizationSlug: 'REFERENCE_NUMBERS',
  },
  {
    dataField: 'shipper',
    text: 'Shipper',
    type: 'customer',
    hideable: true,
    sort: true,
    localizationSlug: 'SHIPPER',
  },
  {
    dataField: 'shipper.status',
    sort: true,
    hideable: true,
    text: 'Shipper Status',
    type: 'service_watch',
    localizationSlug: 'SHIPPER_STATUS',
  },
  {
    dataField: 'origin[0]',
    text: 'Origin',
    type: 'location',
    sort: true,
    hideable: true,
    titleize: true,
    headerStyle: {
      width: '10%',
    },
    localizationSlug: 'ORIGIN',
  },
  {
    dataField: 'destination[0]',
    text: 'Destination',
    type: 'location',
    hideable: true,
    sort: true,
    headerStyle: {
      width: '10%',
    },
    localizationSlug: 'DESTINATION',
  },
  {
    dataField: 'pickup',
    text: 'Pickup',
    type: 'daterange',
    hideable: true,
    sort: true,
    formatExtraData: {
      type: 'pickup',
      isAdmin: true,
    },
    localizationSlug: 'PICKUP',
    titleize: true,
  },
  {
    dataField: 'deliver',
    text: 'Deliver',
    type: 'daterange',
    hideable: true,
    sort: true,
    formatExtraData: {
      type: 'deliver',
      isAdmin: true,
    },
    titleize: true,
    localizationSlug: 'DELIVER',
  },
  {
    dataField: 'reference_numbers',
    text: 'Equipments',
    type: 'equipments',
    hideable: true,
    titleize: true,
    sort: true,
    localizationSlug: 'EQUIPMENTS',
  },
  {
    dataField: 'loads',
    text: 'Load',
    type: 'loaddetails',
    sort: true,
    hideable: true,
    localizationSlug: 'LOAD',
  },
  {
    dataField: 'carrier',
    text: 'Carrier',
    type: 'customer',
    sort: true,
    hideable: true,
    localizationSlug: 'CARRIER',
  },
  {
    dataField: 'driver',
    text: 'Driver',
    type: 'customer',
    hideable: true,
    sort: true,
    localizationSlug: 'DRIVER',
  },
  {
    dataField: 'tags',
    text: 'Tags',
    type: 'tags',
    hideable: true,
    sort: false,
    localizationSlug: 'TAGS',
  },
  {
    dataField: 'total_receivable_rate',
    text: 'Shipper Cost',
    type: 'shipper_cost',
    hideable: true,
    sort: false,
    localizationSlug: 'SHIPPER_COST',
  },
  {
    dataField: 'total_payable_rate',
    text: 'Carrier Payout',
    type: 'carrier_payout',
    hideable: true,
    sort: false,
    localizationSlug: 'CARRIER_PAYOUT',
  },
  {
    dataField: 'missing_docs',
    text: 'Missing POD',
    type: 'boolean',
    hideable: true,
    sort: true,
    localizationSlug: 'MISSING_DOCUMENTATION',
  },
  {
    dataField: 'actual_progress_percentage',
    text: 'Progress',
    type: 'sla',
    hideable: true,
    titleize: true,
    sort: true,
    localizationSlug: 'PROGRESS',
  },
];

export default {
  columns,
};
